var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFavoriteOffIcon = function SvgFavoriteOffIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.95 1.998a6.5 6.5 0 0 0-2.488.495l-.292.13a6.5 6.5 0 0 0-1.817 1.28L12 4.256l-.353-.353a6.501 6.501 0 1 0-9.194 9.194l8.84 8.84a1 1 0 0 0 1.414 0l8.84-8.84a6.5 6.5 0 0 0-2.109-10.604 6.5 6.5 0 0 0-2.488-.495m0 2a4.5 4.5 0 0 1 4.16 6.224l-.104.231c-.22.456-.515.871-.873 1.23L12 19.814l-8.133-8.132a4.501 4.501 0 0 1 6.366-6.366l1.06 1.06a1 1 0 0 0 1.414 0l1.06-1.06a4.5 4.5 0 0 1 3.183-1.319Z"
  })));
};
export default SvgFavoriteOffIcon;